export default __webpack_public_path__ + "static/media/nfts-landing.be529332.png";